export enum FinancialSituationTypes {
	Improve = 'improve',
	Same = 'same',
	Worse = 'worse',
}
